// extracted by mini-css-extract-plugin
export default {"step":"Globals_step__lgkBZ","heading":"Globals_heading__4OQ-p"};